import * as React from 'react';

import {useReportReducers} from 'src/js/hooks/useReportReducers';

interface OwnProps {
  reportId: string;
}
type Props = OwnProps;

export const ReportReducerInjector: React.FC<Props> = (props) => {
  const {reportId, children} = props;

  const {reducersInitialized} = useReportReducers(reportId);

  return reducersInitialized ? <>{children}</> : null;
};
